(function () {
  'use strict';
  var bar = document.querySelector('[data-ob-mobile-buybar]');
  var form = document.querySelector('.product-single__box .js-product-form');
  if (!bar || !form) return;
  var originalButton = form.querySelector('.js-product-add');
  var originalActions = form.querySelector('.js-product-buttons');
  var select = form.querySelector('.js-product-variant-select');
  var price = form.querySelector('.js-product-price-text');
  var stickyButton = bar.querySelector('[data-ob-mobile-buybar-add]');
  var stickyLabel = bar.querySelector('[data-ob-mobile-buybar-label]');
  var stickyMeta = bar.querySelector('[data-ob-mobile-buybar-meta]');
  var mobile = window.matchMedia('(max-width: 767px)');

  function sync() {
    if (!originalButton) return;
    stickyButton.disabled = originalButton.disabled || originalButton.classList.contains('disabled');
    var originalLabel = form.querySelector('.js-product-add-text');
    stickyLabel.textContent = originalLabel ? originalLabel.textContent.trim() : (stickyButton.disabled ? 'Sold out' : 'Add to cart');
    var variant = select && select.options[select.selectedIndex];
    var variantText = variant && !/default/i.test(variant.textContent) ? variant.textContent.replace(/\s*-\s*Sold out\s*$/i, '').trim() + ' · ' : '';
    var priceText = price ? price.textContent.replace(/\s+/g, ' ').trim() : '';
    stickyMeta.textContent = variantText + priceText;
  }

  function setVisible(visible) {
    visible = visible && mobile.matches;
    bar.hidden = !visible;
    bar.classList.toggle('is-visible', visible);
    document.body.classList.toggle('ob-mobile-buybar-active', visible);
  }

  function checkPosition() {
    if (!mobile.matches || !originalActions) { setVisible(false); return; }
    setVisible(originalActions.getBoundingClientRect().bottom < 0);
  }

  stickyButton.addEventListener('click', function () {
    sync();
    if (!stickyButton.disabled && originalButton) originalButton.click();
  });
  form.addEventListener('change', function () { window.setTimeout(sync, 0); });
  window.addEventListener('scroll', checkPosition, { passive: true });
  window.addEventListener('resize', checkPosition, { passive: true });
  if (mobile.addEventListener) mobile.addEventListener('change', checkPosition);
  new MutationObserver(sync).observe(form, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
  sync();
  checkPosition();
})();
